import {chunkString} from '../../../string';

export const getDaySchedule = (schedule: string, dayIndex: number): string => {
  const daysSchedule = chunkString(schedule, 24);

  if (!daysSchedule[dayIndex]) {
    throw new Error(`Day index ${dayIndex} is out of range`);
  }

  return daysSchedule[dayIndex]!;
};
